import { useNavigate } from 'react-router-dom';

const LoginOptionsPage = () => {
  const navigate = useNavigate();

  const loginOptions = [
    {
      title: 'Candidate Login',
      description: 'Job seekers and candidates',
      route: '/login',
      color: 'from-[#050B3A] to-[#1B2BD6]',
      icon: '👤'
    },
    {
      title: 'HR Login',
      description: 'HR managers and recruiters',
      route: '/hr_login',
      color: 'from-[#059669] to-[#10b981]',
      icon: '💼'
    },
    {
      title: 'Course Provider',
      description: 'Educational content providers',
      route: '/course_login',
      color: 'from-[#059669] to-[#10b981]',
      icon: '🎓'
    },
    {
      title: 'SaaS Provider',
      description: 'Software service providers',
      route: '/saas_login',
      color: 'from-[#7c3aed] to-[#a855f7]',
      icon: '⚙️'
    },
    {
      title: 'Super Admin',
      description: 'Platform administrators',
      route: '/superadmin_login',
      color: 'from-[#dc2626] to-[#ef4444]',
      icon: '🔐'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#f1eef6] to-[#e5e7eb] flex items-center justify-center p-4">
      <div className="max-w-4xl w-full">
        
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-[#2b0f4b] mb-4">
            Choose Your Login Type
          </h1>
          <p className="text-lg text-[#5b556f]">
            Select the appropriate login portal for your account type
          </p>
        </div>

        {/* Login Options Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {loginOptions.map((option, index) => (
            <div
              key={index}
              onClick={() => navigate(option.route)}
              className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:scale-105 p-6 border border-gray-100"
            >
              <div className="text-center">
                <div className="text-4xl mb-4">{option.icon}</div>
                <h3 className="text-xl font-bold text-[#2b0f4b] mb-2">
                  {option.title}
                </h3>
                <p className="text-[#5b556f] text-sm mb-4">
                  {option.description}
                </p>
                <button
                  className={`w-full py-3 px-6 bg-gradient-to-r ${option.color} text-white font-semibold rounded-lg hover:opacity-90 transition-opacity`}
                >
                  Sign In
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Back to Home */}
        <div className="text-center">
          <button
            onClick={() => navigate('/')}
            className="text-[#8b5cf6] hover:text-[#7c3aed] font-medium transition-colors"
          >
            ← Back to Home
          </button>
        </div>

      </div>
    </div>
  );
};

export default LoginOptionsPage;
